import React from 'react';
import store from 'store';

import { Button } from 'components/Button';
import Text from 'components/Text';

import { ProtocolButtonProps } from './interface';

const ProtocolButton: React.FC<ProtocolButtonProps> = ({ data }) => (
  <Button
    onClick={() => store.dispatch({
      type: 'OPEN_CARD',
      data: {
        id: data.cardId,
        protocolNumber: data.protocolNumber,
        ticketId: data.id,
        ticketDevolution: data.ticketDevolution || null,
        ticketReason: data.ticketReason,
        responsibleGroup: data.responsibleGroup
      },
    })}
    width="auto"
  >
    <Text className="color-blue-gray font-bold" size={12}>
      {data.protocolNumber}
    </Text>
  </Button>
);

export default ProtocolButton;